// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 56px;
  background-color: #1a1a2e;
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header h1 {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 600;
}

.header button {
  padding: 8px 16px;
  border: 1px solid #ffffff;
  background: transparent;
  color: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
}

.header button:hover {
  background: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 56px;\n  background-color: #1a1a2e;\n  color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.header h1 {\n  font-size: 1.25rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n.header button {\n  padding: 8px 16px;\n  border: 1px solid #ffffff;\n  background: transparent;\n  color: #ffffff;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.header button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
